import { batchConstants } from "../actions/constants/batchConstants";

export const getBatchReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getBatchRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.getBatchSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchdata: action.payload
            }
        case batchConstants.getBatchFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const createBatchReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.batchCreateRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.batchCreateSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchdata: action.payload
            }
        case batchConstants.batchCreateFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getBatchParamsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getBatchParamsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.getBatchParamsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchdata: action.payload
            }
        case batchConstants.getBatchParamsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const deleteBatchReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.batchDeleteRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.batchDeleteSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchdelete: action.payload
            }
        case batchConstants.batchDeleteFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const toggleBatchReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.batchToggleRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.batchToggleSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchdata: action.payload
            }
        case batchConstants.batchToggleFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}


export const getAvailableUsersReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getAvailableUsersRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.getAvailableUsersSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                availableUsers: action.payload
            }
        case batchConstants.getAvailableUsersFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const viewBatchReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.batchViewRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.batchViewSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                batchData: action.payload
            }
        case batchConstants.batchViewFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getAvailableStudentsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getAvailableStudentsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.getAvailableStudentsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                availableStudents: action.payload
            }
        case batchConstants.getAvailableStudentsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}


export const markAttendanceReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.attendanceMarkedRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case batchConstants.attendanceMarkedSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                attendance: action.payload
            }
        case batchConstants.attendanceMarkedFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getBatchHistoryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getBatchHistoryRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false,
            }
        case batchConstants.getBatchHistorySuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                historyData: action.payload,
            }
        case batchConstants.getBatchHistoryFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload,
            }
        case batchConstants.getBatchHistoryReset:
            return {}
        default:
            return state;
    }
}

export const getOverallStudentAnalyticsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getOverallStudentAnalyticsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false,
            }
        case batchConstants.getOverallStudentAnalyticsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                overallStudentAnalytics: action.payload,
            }
        case batchConstants.getOverallStudentAnalyticsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload,
            }
        default:
            return state;
    }
}

export const getSessionAnalyticsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getSessionAnalyticsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false,
            }
        case batchConstants.getSessionAnalyticsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                sessionAnalytics: action.payload,
            }
        case batchConstants.getSessionAnalyticsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload,
            }
        default:
            return state;
    }
}


export  const getAvailableStudentsForBatchReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getAvailableStudentsForBatchRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false,
            }
        case batchConstants.getAvailableStudentsForBatchSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                availableStudents: action.payload,
            }
        case batchConstants.getAvailableStudentsForBatchFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload,
            }
        default:
            return state;
    }
}


export const getCalendarDetailsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case batchConstants.getCalendarDetailsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false,
            }
        case batchConstants.getCalendarDetailsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                calendarDetails: action.payload,
            }
        case batchConstants.getCalendarDetailsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload,
            }
        default:
            return state;
    }
}
